import React, { useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const fillRef = useRef(null);

  useEffect(() => {
    let frame;
    const animate = () => {
      const t = Date.now() / 1000; 

    // All waves use high frequency multipliers
    const y1 = 200 + Math.sin(t * 2.0)       * 100; 
    const y2 = 240 + Math.sin(t * 2.0 + 0.8) * 100;  
    const y3 = 190 + Math.sin(t * 2.0 + 1.6) * 100;  
    const y4 = 250 + Math.sin(t * 2.0 + 2.4) * 100;  
    const y5 = 200 + Math.sin(t * 2.0 + 3.2) * 100;  
    const y6 = 230 + Math.sin(t * 2.0 + 4.0) * 100;  
    const y7 = 195 + Math.sin(t * 2.0 + 4.8) * 100;  
    const y8 = 220 + Math.sin(t * 2.0 + 5.6) * 100;  

      const fillD = `
        M0,0 L1440,0
        L1440,${y8}
        C1260,${y7} 1080,${y6} 900,${y5}
        C720,${y4}  540,${y3}  360,${y2}
        C180,${y1}  90,${y1}   0,${y1}
        Z
      `;

      if (fillRef.current) fillRef.current.setAttribute('d', fillD);

      frame = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <section id="about" className="about-section">

      <div className="about-background">
        <svg className="wave-svg" viewBox="0 0 1440 400" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="greenGrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%"   stopColor="rgba(20,100,55,0.80)"  />
              <stop offset="55%"  stopColor="rgba(35,130,75,0.45)" />
              <stop offset="100%" stopColor="rgba(0, 0, 0, 0)" />
            </linearGradient>
          </defs>
          <path ref={fillRef} fill="url(#greenGrad)" />
        </svg>
      </div>

      <div className="about-card">
        <span className="about-label">WHY AIVION</span>

        <h2>
          Delivering meaningful outcomes,
          <br />
          Built on Trusted Data.
        </h2>

        <div className="about-quote">
          <p>
            "AIVION combines deep domain expertise with practical,
            commercially focused AI implementation to deliver measurable
            business outcomes across regulated industries."
          </p>
        </div>

        <div className="about-features">
          <div className="feature">DATA & AI EXPERTISE</div>
          <div className="feature">REGULATED INDUSTRIES</div>
          <div className="feature">PRODUCTION-READY SOLUTIONS</div>
        </div>
      </div>

    </section>
  );
};

export default About;
